import React, { useState, useEffect } from 'react';

// Define interfaces for your question structure
interface QuestionOption {
  dependentOn?: string;
  question: string;
  options: string[];
  isMultiSelection?: boolean;
}

interface Question extends QuestionOption {
  dependentQuestions?: QuestionOption[];
}

const questionsData: Question[] = [
  {
    question: 'Avez-vous une voiture?',
    options: ['Oui', 'Non'],
    isMultiSelection: false,
    dependentQuestions: [
      {
        dependentOn: 'Oui',
        question: 'De quel type?',
        options: ['Électrique', 'Citadine', 'SUV', 'Familiale']
      },
      {
        dependentOn: 'Oui',
        question: 'De quelle couleur?',
        options: ['Bleu', 'Vert', 'Rouge', 'Noir', 'Grise', 'Marron', 'Jaune', 'Blanc', 'Orange', 'Rose']
      }
    ]
  },
  {
    question: 'Quel type de route préférez-vous?',
    options: ['Autoroute', 'Nationale', 'ça dépend'],
    isMultiSelection: true
  },
  {
    question: 'Combien de place disponible dans votre voiture?',
    options: ['1', '2', '3', '4', '5', '6'],
    isMultiSelection: false
  },
  {
    question: 'Quel est votre moyen de transport favori en ville?',
    options: ['Piéton', 'Transport Publics', 'Trottinette', 'Vélo'],
    isMultiSelection: false
  },
  {
    question: 'Quels jours pensez-vous covoiturer habituellement?',
    options: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
    isMultiSelection: true
  },
  {
    question: "Préférez-vous être à l'arrière ou à l'avant?",
    options: ['Arrière', 'Avant'],
    isMultiSelection: false
  },
  {
    question: 'Transportez-vous une trottinette?',
    options: [' Oui', 'Non'],
    isMultiSelection: false
  }
];

// Define an interface for responses
interface Response {
  question: string;
  answer: string | string[];
}

function QuizComponent() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [responses, setResponses] = useState<Response[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [dependentQuestions, setDependentQuestions] = useState<QuestionOption[]>([]);
  const [currentDependentQuestion, setCurrentDependentQuestion] = useState<QuestionOption | null>(null);

  useEffect(() => {
    // Automatically move to the next main question if there are no dependent questions left to display
    if (dependentQuestions.length === 0 && currentDependentQuestion !== null) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setCurrentDependentQuestion(null);
    }
  }, [currentDependentQuestion, currentQuestionIndex, dependentQuestions.length]);

  const handleOptionSelect = (option: string): void => {
    const currentQuestion = questionsData[currentQuestionIndex];

    setSelectedOptions([option]); // Update for single selection logic

    if (!currentQuestion.isMultiSelection) {
      const matchedDependentQuestions = currentQuestion.dependentQuestions?.filter((dq) => dq.dependentOn === option) || [];
      if (matchedDependentQuestions.length > 0) {
        setDependentQuestions(matchedDependentQuestions);
        setCurrentDependentQuestion(matchedDependentQuestions[0]);
      } else {
        // No dependent questions, so proceed to capture response and move to next question
        goToNextQuestion(option);
      }
    }
  };

  const goToNextQuestion = (selectedOption?: string): void => {
    const responseQuestion = currentDependentQuestion ? currentDependentQuestion.question : questionsData[currentQuestionIndex].question;
    const newResponse: Response = {
      question: responseQuestion,
      answer: selectedOption!
    };
    setResponses((prevResponses) => [...prevResponses, newResponse]);

    // Advance to the next dependent question or main question as appropriate
    const nextDependentIndex = currentDependentQuestion ? dependentQuestions.findIndex((dq) => dq === currentDependentQuestion) + 1 : 0;
    if (currentDependentQuestion && nextDependentIndex < dependentQuestions.length) {
      setCurrentDependentQuestion(dependentQuestions[nextDependentIndex]);
    } else {
      setCurrentDependentQuestion(null); // This will trigger the useEffect to move to the next main question
      setDependentQuestions([]); // Clear dependent questions
    }
    setSelectedOptions([]); // Reset selections for the next question
  };

  // Determine what to display as the current question
  const displayQuestion = currentDependentQuestion || questionsData[currentQuestionIndex];

  return (
    <div>
      <h2>{displayQuestion.question}</h2>
      {displayQuestion.options.map((option, index) => (
        <button
          key={index}
          onClick={() => handleOptionSelect(option)}
          style={{ backgroundColor: selectedOptions.includes(option) ? 'lightblue' : 'yellow', color: 'black', marginRight: 20, width: '80px', height: '44px' }}
        >
          {option}
        </button>
      ))}
      {displayQuestion.isMultiSelection && <button onClick={() => goToNextQuestion(selectedOptions.join(', '))}>Next</button>}
    </div>
  );
}

export default QuizComponent;
